import { useQuery } from '@tanstack/react-query';
import { useAuthStore } from '../auth/authStore';
import { fetchDepositOrders } from './api';

export const DEPOSIT_ORDERS_QUERY_KEY = 'wallet-deposit-orders';

/**
 * Shared by the Unpaid Deposits page and the Me-menu badge so both read one
 * cache entry. `poll` defaults to true (the Unpaid Deposits page needs live
 * updates while a proof is under review); pass `{ poll: false }` for a
 * badge-only read — the Me tab does not need every player in every market
 * hitting this endpoint every 30s just to show a count that staleTime/
 * refetch-on-mount already keeps reasonably fresh.
 */
export function useDepositOrders(options?: { poll?: boolean }) {
  const poll = options?.poll ?? true;
  const token = useAuthStore((state) => state.token);
  const guestMode = useAuthStore((state) => state.guestMode);
  return useQuery({
    queryKey: [DEPOSIT_ORDERS_QUERY_KEY, token],
    queryFn: () => fetchDepositOrders(token || ''),
    enabled: !!token && !guestMode,
    staleTime: 15_000,
    ...(poll ? { refetchInterval: () => (typeof document !== 'undefined' && document.visibilityState === 'visible' ? 30_000 : false) } : {}),
  });
}
